import React, { useState } from 'react';
import { SCENES } from './scenes/index.jsx';
import { SCENES2 } from './scenes/topic2.jsx';
import { SCENES3 } from './scenes/topic3.jsx';
import { SCENES_AM } from './scenes/amateur.jsx';
import { SCENES_PAT } from './scenes/patterns.jsx';
import { SCENES_CANDLE } from './scenes/candles.jsx';
import { SCENES_ADV } from './scenes/advanced.jsx';
import { COLORS } from '../theme.js';
const ALL = { ...SCENES, ...SCENES2, ...SCENES3, ...SCENES_AM, ...SCENES_PAT, ...SCENES_CANDLE, ...SCENES_ADV };

/* Two-tone heading: last word coloured */
const Title = ({ text, color }) => <h1 className="h">{text.split(' ').slice(0, -1).join(' ')} <em style={{ color }}>{text.split(' ').slice(-1)}</em></h1>;

/*
 * One subtopic = a reference NOTES page: infographic on top, then always-visible note sections.
 * No games, no tap-to-reveal, no completion tracking. Prev/next navigation at the bottom.
 */
function Subtopic({ s, n, total, color, onBack, onPrev, onNext }) {
  const Scene = ALL[s.scene];
  return (<article className="sub notes" style={{ '--k': color }}>
    <button className="back" data-testid="infographic-back-overview" onClick={onBack}>← Topic overview</button>
    <span className="badge mono" style={{ background: color }}>SUBTOPIC {n} / {total}</span>
    <Title text={s.title} color={color} />
    <div className="step mono">📊 INFOGRAPHIC</div>
    {Scene && <Scene />}
    <div className="step mono">📝 NOTES</div>
    <div className="notelist">{s.cards.map((c, i) => <section key={i} className="note" style={{ '--k': COLORS[(i * 3 + n) % COLORS.length] }}>
      <span className="ni">{c.icon}</span><div><h3>{c.title}</h3><p>{c.body}</p></div></section>)}</div>
    <nav className="botnav" data-testid="infographic-bottom-nav">
      <button className="btn ghost" data-testid="infographic-bottom-back" onClick={onBack}>← Back</button>
      <button className="btn ghost" data-testid="infographic-prev-btn" disabled={n === 1} onClick={onPrev}>‹ Prev</button>
      <button className="btn" data-testid="infographic-next-btn" onClick={onNext}>{n === total ? 'Back to topic' : 'Next ›'}</button>
    </nav>
  </article>);
}

export default function SubtopicTopic({ topic, num, onBack }) {
  const [cur, setCur] = useState(null); const go = i => { setCur(i); scrollTo(0, 0); };
  const total = topic.subtopics.length;
  if (cur !== null) return <Subtopic key={cur} s={topic.subtopics[cur]} n={cur + 1} total={total} color={COLORS[cur % COLORS.length]}
    onBack={() => go(null)} onPrev={() => go(cur - 1)} onNext={() => go(cur + 1 < total ? cur + 1 : null)} />;
  return (<article>
    <button className="back" data-testid="infographic-back-topic-list" onClick={onBack}>← Back to topics</button>
    <span className="badge mono" style={{ background: COLORS[0] }}>TOPIC {num}</span>
    <Title text={topic.title} color={COLORS[num % COLORS.length]} />
    {topic.summary && <p className="muted">{topic.summary}</p>}
    {topic.subtopics.map((s, i) => { const c = COLORS[i % COLORS.length];
      return <button key={i} data-testid={`infographic-subtopic-${i + 1}`} className="card topic sublist" onClick={() => go(i)} style={{ borderLeft: `5px solid ${c}` }}>
        <span className="badge mono n" style={{ background: c }}>{String(i + 1).padStart(2, '0')}</span>
        <div><b>{s.title}</b><small className="muted">{s.cards.length} notes</small></div>
        <span className="state">›</span></button>; })}
    <div className="botnav" data-testid="infographic-bottom-nav">
      <button className="btn ghost" data-testid="infographic-bottom-back" onClick={onBack}>← Back</button>
      <button className="btn" data-testid="infographic-bottom-next" onClick={() => go(0)}>Start ›</button>
    </div>
  </article>);
}
